<template>
  <div class="col-md-6 col-lg-12">
    <div class="auction-item-6">
      <div class="auction-inner">
        <div class="auction-thumb border-radius-5">
          <vue-skeleton-loader
            type="rect"
            animation="fade"
            width="100%"
            height="100%"
          />
        </div>
        <div class="auction-content">
          <vue-skeleton-loader
            class="mb-3"
            type="rect"
            animation="fade"
            width="80%"
            height="30px"
            style="margin: 0 auto"
          />
          <div class="row text mt-3">
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row text mt-2">
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row text mt-2 d-none d-lg-flex">
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row text mt-2 d-none d-lg-flex">
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
                <div class="col-6 col-lg-12">
                  <vue-skeleton-loader
                    class="mb-2"
                    type="rect"
                    animation="fade"
                    width="100%"
                    height="15px"
                  />
                </div>
              </div>
            </div>
          </div>
          <vue-skeleton-loader
            class="mx-auto mt-2 border-radius-30 d-lg-none d-block"
            type="rect"
            animation="fade"
            width="80%"
            height="50px"
          />
        </div>
        <div class="auction-bidding d-none d-lg-block">
          <vue-skeleton-loader
            class="mb-3"
            type="rect"
            animation="fade"
            width="80%"
            height="15px"
            style="margin: 0 auto"
          />
          <vue-skeleton-loader
            class="mb-3"
            type="rect"
            animation="fade"
            width="80%"
            height="20px"
            style="margin: 0 auto"
          />
          <vue-skeleton-loader
            class="mx-auto mt-2 border-radius-30"
            type="rect"
            animation="fade"
            width="80%"
            height="50px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSkeletonLoader from 'skeleton-loader-vue';
export default {
  props: {
    classeRaiz: {
      type: String,
    },
  },
  components: {
    VueSkeletonLoader,
  },
};
</script>

<style>
.center {
  display: flex;
  justify-content: center;
}
</style>
